import { ActionType, createAction } from "typesafe-actions";

import LongLat from "@mapmycustomers/shared/types/base/LongLat";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

export const openOnMapPage = createAction("map/openOnMapPage")<{
  mapViewState: Partial<MapViewState>;
  openOnNewTab?: boolean;
  viewport?: Partial<{ center: LongLat; zoom: number }>;
}>();

export const setOfferedFilters = createAction("map/filtering/setOfferedFilter")<
  MapFilterModel | undefined
>();

export type Actions = ActionType<typeof openOnMapPage | typeof setOfferedFilters>;
